var map = {
	"./001-web-design.svg": "498d",
	"./002-graphic-design-5.svg": "e0ca",
	"./003-graphic-design-4.svg": "ee44",
	"./004-storyboard.svg": "a8fd",
	"./005-sketchbook.svg": "9c36",
	"./006-pros-and-cons.svg": "2ac9",
	"./007-graphic-design-3.svg": "cce7",
	"./008-grid.svg": "4848",
	"./009-perspective.svg": "dbf4",
	"./010-tablet.svg": "195f",
	"./011-idea-1.svg": "840e",
	"./012-innovation.svg": "791d",
	"./013-vector.svg": "1989",
	"./014-idea.svg": "578c7",
	"./015-flowchart.svg": "3460",
	"./016-graphic-design-2.svg": "fa01",
	"./017-graphic-design-1.svg": "1972",
	"./018-graphic-design.svg": "2ce4",
	"./019-work-station.svg": "0f23",
	"./020-design-tool.svg": "6ec5",
	"./021-smartphone.svg": "3774",
	"./022-chat.svg": "e7e5",
	"./023-anchor.svg": "1426",
	"./024-brainstorm.svg": "19a7",
	"./025-copyright.svg": "b2b8",
	"./026-management.svg": "5dc9",
	"./027-graphic-tool.svg": "c2c1",
	"./028-comparison.svg": "6418",
	"./029-pantone.svg": "4f4a",
	"./030-architecture.svg": "058a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d372";